import { useState, useEffect } from 'react';

export default function useWindowWidth() {
  const [width, setWidth] = useState(() =>
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );
  useEffect(() => {
    const fn = () => setWidth(window.innerWidth);
    window.addEventListener('resize', fn, { passive: true });
    return () => window.removeEventListener('resize', fn);
  }, []);
  return width;
}

// Convenience breakpoint flags
export function useBreakpoints() {
  const [dims, setDims] = useState(() => ({
    w: typeof window !== 'undefined' ? window.innerWidth  : 1024,
    h: typeof window !== 'undefined' ? window.innerHeight : 768,
  }));
  useEffect(() => {
    const fn = () => setDims({ w: window.innerWidth, h: window.innerHeight });
    window.addEventListener('resize', fn, { passive: true });
    return () => window.removeEventListener('resize', fn);
  }, []);
  const { w, h } = dims;
  return {
    width:      w,
    isMobile:   w < 640,
    isTablet:   w >= 640 && w < 1024,
    isDesktop:  w >= 1024,
    isMd:       w >= 768,
    isLandscape: w > h,
    isCompact:  h < 500,   // short viewport — landscape mobile
  };
}
